enum DroppableId {
  LEVEL1_SCROLL_VIEW_LIVING = 'level1ScrollViewLiving',
  LEVEL1_SCROLL_VIEW_NONLIVING = 'level1ScrollViewNonliving',
}

export default DroppableId;
